import { STORAGE_KEYS } from "../constants"

export const storage = {
  getToken() {
    if (typeof localStorage === "undefined") return null
    const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
    return token ?? null
  },

  setToken(token) {
    if (typeof localStorage === "undefined") return
    localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token)
  },

  removeToken() {
    if (typeof localStorage === "undefined") return
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
  },

  hasToken() {
    return storage.getToken() != null
  },

  getTheme() {
    if (typeof localStorage === "undefined") return null
    const theme = localStorage.getItem(STORAGE_KEYS.THEME)
    return theme ?? null
  },

  setTheme(theme) {
    if (typeof localStorage === "undefined") return
    localStorage.setItem(STORAGE_KEYS.THEME, theme)
  }
}
